import axios from 'axios'

const getHeaders = (jwt: string) => ({
    'Authorization': 'Bearer ' + jwt,
})

export const createPayment = (apiUrl: string, jwt: string) => async (terminalId: number, paymentId: number, amount: number, currency: string): Promise<Record<string, any> | null> => {
    const response = await axios.post(
        `${apiUrl}/payment/create/${terminalId}/${paymentId}`,
        { amount, currency },
        { headers: getHeaders(jwt) },
    )

    return response.data.transaction
}

export const fetchTransactionStatus = (apiUrl: string, jwt: string) => async (terminalId: number, transactionId: number): Promise<Record<string, any>> => {
    const response = await axios.get(`${apiUrl}/payment/status/${terminalId}/${transactionId}`, {
        headers: getHeaders(jwt),
    })

    return response.data.transaction
}

export const abortPayment = (apiUrl: string, jwt: string) => async (terminalId: number, transactionId: number): Promise<void> => {
    await axios.post(`${apiUrl}/payment/abort/${terminalId}/${transactionId}`, undefined, {
        headers: getHeaders(jwt),
    })
}
